// Common
import { ComponentRef, Directive, Input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

// Components
import { SidebarContextMenuComponent } from '@modules/notes/components/sidebar-context-menu/sidebar-context-menu.component';

// Types
import { type NotesRailKey, type NotesRailScope } from '../components/sidebar-context-menu/notes-rail-menu';

@Directive({
  selector: '[appSidebarContextMenu]',
  standalone: false,
})
export class SidebarContextMenuDirective extends ContextMenuDirective {
  // Inputs
  @Input() appSidebarContextMenu: NotesRailKey;
  @Input() appSidebarContextMenuTenantId: string | null | undefined;
  /** A workspace rail row: the menu is the shared rail menu (`notes-rail-menu.ts`). */
  @Input() appSidebarContextMenuRail = false;
  /** Whether the row belongs to the member's My Workspace or to the Team Workspace. */
  @Input() appSidebarContextMenuRailScope: NotesRailScope = 'mine';

  registerComponent() {
    return SidebarContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<SidebarContextMenuComponent>) {
    componentRef.instance.sidebarFilterKey = this.appSidebarContextMenu;
    componentRef.instance.railOrigin = this.elementRef.nativeElement;
    componentRef.instance.tenantId = this.appSidebarContextMenuTenantId;
    componentRef.instance.rail = this.appSidebarContextMenuRail;
    componentRef.instance.railScope = this.appSidebarContextMenuRailScope;
  }
}
